import styled from "@emotion/styled";
import { Button, ListBox, ListBoxItem, Popover, Select, SelectValue } from "react-aria-components";
import { IMDSSelectItemProps, IMDSSelectProps } from "./select.types";

export const StyledSelect = styled(Select)<IMDSSelectProps>``;

export const StyledListBox = styled(ListBox)`
  width: 100%;
  max-height: 200px;
  overflow-y: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
` as typeof ListBox<IMDSSelectItemProps>;

export const StyledListBoxItem = styled(ListBoxItem)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["5"]};
  width: 100%;
  font-size: ${({ theme }) => theme.fontSizes["text-sm"]};

  outline: none;

  user-select: none;
  cursor: pointer;

  &[data-focused] {
    background-color: ${({ theme }) => theme.colors.background.menu.selected};
  }

  &[data-selected] {
    background-color: ${({ theme }) => theme.colors.background.menu.emphasized};
  }

  &:hover:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.background.menu.hover};
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledSelectValue = styled(SelectValue)`
  max-width: 100%;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.text.primary};

  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledButton = styled(Button)``;

export const StyledButtonContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const StyledPopover = styled(Popover)`
  background: ${({ theme }) => theme.colors.surface.menu};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  padding-block: ${({ theme }) => theme.spacing["3"]};
`;

// menu-header in Figma
// https://www.figma.com/design/NtKUlPYqtoSzzG4BFh55KG/-Redesign--Mem-Design-System?node-id=7336-32721&t=KwbAgWREqjcX2XvC-4
export const StyledPopoverHeader = styled.div<{ $position: "top" | "middle" }>`
  display: flex;
  width: 100%;
  padding: ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["2"]}
    ${({ theme }) => theme.spacing["2"]} ${({ theme }) => theme.spacing["5"]};
  justify-content: space-between;
  align-items: center;

  ${({ $position, theme }) => $position === "middle" && `padding-top: ${theme.spacing["3"]};`}
`;
